/**
 * Determine if the user is from New Zealand
 * @param  {string} country
 * @return {boolean}
 */
export const isNZCheck = ({ country }) => (country || '').toLowerCase() === 'nz';

export const isInternalStaffCheck = (planName) => {
  const internalStaff = ['Internal Staff', 'Corporate Accounts', 'Friends and family', 'Family and friends'];
  return internalStaff.some((name) => new RegExp(`^${name}`, 'i').test(planName));
};
